var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3311 2.10818C18.3311 2.10818 17.4255 0 16.0424 0C14.6812 0 13.9731 0.624546 13.5011 1.05545C13.0291 1.48636 5.13094 7.93636 5.13094 7.93636C5.13094 7.93636 2.83395 9.93 3.00958 13.68C3.15778 17.43 3.896 22.7673 7.72707 30.2018C11.5307 37.62 21.0507 48.9545 27.0663 52.9391C27.0663 52.9391 32.64 57.1882 37.8268 58.9145C39.3334 59.3864 42.3467 60 43.0492 60C43.7627 60 45.0224 60 46.4686 58.95C47.9396 57.8891 56.1918 51.2945 56.1918 51.2945C56.1918 51.2945 58.2116 49.4809 55.8652 47.3727C53.5078 45.2645 46.3506 40.5764 44.8193 39.3436C43.2852 38.0918 41.1007 38.6427 40.1567 39.4909C39.2154 40.3445 37.5331 41.7491 37.3273 41.9264C37.0199 42.1609 36.1774 42.9218 35.2334 42.5427C34.0314 42.0709 29.1026 39.4118 24.5333 33.1991C19.9914 26.9918 19.492 24.9627 18.8141 22.77C18.6992 22.4459 18.6976 22.0926 18.8096 21.7675C18.9217 21.4423 19.1408 21.1642 19.4316 20.9782C20.1122 20.5091 22.6178 18.4336 22.6178 18.4336C22.6178 18.4336 24.2396 16.8436 23.5618 14.97C22.884 13.0964 18.3311 2.10818 18.3311 2.10818Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvgrepocom);
export default __webpack_public_path__ + "static/media/phone_svgrepo.com.d981227bc6cff0d40047753f8c3e2fa1.svg";
export { ForwardRef as ReactComponent };